/**
 * 为拾取目标生成不含 DOM id 的 CSS 选择器。
 * 每段 `tag.class`，同标签同级不止一个时追加 `:nth-of-type` 锚定具体那个，
 * 段内兄弟间天然唯一，于是从 body 下来的全路径必唯一；再退回最短唯一后缀，
 * 让结果读起来更接近人写的选择器。
 * 约束来自服务端 proactiveSelectorSchema：不收 IdSelector，也不收 id 属性选择器。
 */
export function buildUniqueSelector(element: Element): string {
  const segments: string[] = [];
  for (
    let node: Element | null = element;
    node && node !== document.documentElement;
    node = node.parentElement
  ) {
    segments.unshift(segment(node));
  }
  for (let length = 1; length <= segments.length; length++) {
    const candidate = segments.slice(-length).join(" > ");
    if (isUnique(candidate)) return candidate;
  }
  return segments.join(" > ");
}

/** 选择器只保证当前页面唯一命中；跨商品、跨模板是否仍有效不做保证。 */
export function isUniqueMatch(selector: string, element: Element): boolean {
  try {
    const matches = document.querySelectorAll(selector);
    return matches.length === 1 && matches[0] === element;
  } catch {
    return false;
  }
}

function segment(element: Element): string {
  const tag = element.localName;
  const classes = [...element.classList]
    .map((name) => `.${CSS.escape(name)}`)
    .join("");
  const sameTagSiblings = element.parentElement
    ? [...element.parentElement.children].filter(
        (sibling) => sibling.localName === tag,
      )
    : [element];
  const nth =
    sameTagSiblings.length > 1
      ? `:nth-of-type(${String(sameTagSiblings.indexOf(element) + 1)})`
      : "";
  return `${tag}${classes}${nth}`;
}

function isUnique(selector: string): boolean {
  try {
    return document.querySelectorAll(selector).length === 1;
  } catch {
    return false;
  }
}
